import { z } from 'zod';
export const giveawayEndpointIds = {
    CREATE_GIVEAWAY: 'CREATE_GIVEAWAY',
    CREATE_GIVEAWAY_ENTRY: 'CREATE_GIVEAWAY_ENTRY',
    CREATE_GIVEAWAY_ENTRY_CALLBACK: 'CREATE_GIVEAWAY_ENTRY_CALLBACK',
    GIVEAWAYS_RESOLVE: 'GIVEAWAYS_RESOLVE',
    GIVEAWAYS_CANCEL_EXPIRED_WAITING: 'GIVEAWAYS_CANCEL_EXPIRED_WAITING',
    REDEEM_REWARD: 'REDEEM_REWARD',
    ENTER_GIVEAWAY: 'ENTER_GIVEAWAY',
    GET_USER_GIVEAWAYS: 'GET_USER_GIVEAWAYS',
    GET_USER_GIVEAWAY_REWARDS: 'GET_USER_GIVEAWAY_REWARDS',
    GET_GIVEAWAY: 'GET_GIVEAWAY',
    IS_GIVEAWAY_ACTION_DONE: 'IS_GIVEAWAY_ACTION_DONE',
    SEND_GIVEAWAY_SUMMARIES: 'SEND_GIVEAWAY_SUMMARIES',
    SAVE_GIVEAWAY_TERMS: 'SAVE_GIVEAWAY_TERMS',
    GET_USER_GIVEAWAY_TERMS: 'GET_USER_GIVEAWAY_TERMS',
    GET_USER_VOUCHERS: 'GET_USER_VOUCHERS',
    GET_USER_GIVEAWAY_STATISTICS: 'GET_USER_GIVEAWAY_STATISTICS',
    GET_USER_ACTIVE_GIVEAWAY_SCHEDULER: 'GET_USER_ACTIVE_GIVEAWAY_SCHEDULER',
    UPDATE_USER_GIVEAWAY_SCHEDULER: 'UPDATE_USER_GIVEAWAY_SCHEDULER',
    GET_USER_AVAILABLE_ACTIONS: 'GET_USER_AVAILABLE_ACTIONS',
    CREATE_GIVEAWAY_SCHEDULE: 'CREATE_GIVEAWAY_SCHEDULE',
    GET_VOUCHERS_COUNT: 'GET_VOUCHERS_COUNT',
    SEND_CHAT_GIVEAWAY_LINK: 'SEND_CHAT_GIVEAWAY_LINK',
    GET_GIVEAWAY_ENTER_LINK: 'GET_GIVEAWAY_ENTER_LINK',
    GET_ADMIN_GIVEAWAYS: 'GET_ADMIN_GIVEAWAYS',
    CANCEL_GIVEAWAY: 'CANCEL_GIVEAWAY',
};
export var VerifySteamStage;
(function (VerifySteamStage) {
    VerifySteamStage["SIGN_IN"] = "SIGN_IN";
    VerifySteamStage["SUCCESS"] = "SUCCESS";
    VerifySteamStage["ERROR"] = "ERROR";
})(VerifySteamStage || (VerifySteamStage = {}));
export const giveawayAnalyticsEvents = {
    CREATE_GIVEAWAY: 'create_giveaway',
    EDIT_GIVEAWAY_SCHEDULE: 'edit_giveaway_schedule',
    CREATE_GIVEAWAY_SCHEDULE: 'create_giveaway_schedule',
    CANCEL_GIVEAWAY_SCHEDULE: 'cancel_giveaway_schedule',
    SUBMIT_STEAM_ENTRY: 'submit_steam_entry',
    SUBMIT_STEAM_ENTRY_SUCCESS: 'submit_steam_entry_success',
    SUBMIT_ENTER_GIVEAWAY: 'submit_enter_giveaway',
    SUBMIT_ENTRY_TWITCH: 'submit_entry_twitch',
    SUBMIT_ENTRY_YOUTUBE: 'submit_entry_youtube',
    SUBMIT_ENTRY_TWITCH_SUCCESS: 'submit_entry_twitch_success',
    SUBMIT_ENTRY_YOUTUBE_SUCCESS: 'submit_entry_youtube_success',
    SUBMIT_ENTRY_TWITCH_SUBSCRIPTION: 'submit_entry_twitch_subscription',
    SUBMIT_ENTRY_TWITCH_SUBSCRIPTION_SUCCESS: 'submit_entry_twitch_subscription_success',
    REDEEM_VOUCHER: 'redeem_voucher',
};
export var EntryFailureCode;
(function (EntryFailureCode) {
    EntryFailureCode["NOT_CONNECTED_ACCOUNT"] = "NOT_CONNECTED_ACCOUNT";
    EntryFailureCode["NOT_FOLLOWING"] = "NOT_FOLLOWING";
    EntryFailureCode["EXTERNAL_ERROR"] = "EXTERNAL_ERROR";
    EntryFailureCode["ONLY_SUBSCRIBERS"] = "ONLY_SUBSCRIBERS";
    EntryFailureCode["MAX_WINS_REACHED"] = "MAX_WINS_REACHED";
    EntryFailureCode["BANNED_FROM_CHANNEL"] = "BANNED_FROM_CHANNEL";
})(EntryFailureCode || (EntryFailureCode = {}));
export var SteamErrorCode;
(function (SteamErrorCode) {
    SteamErrorCode["ProfileNotPublic"] = "ProfileNotPublic";
    SteamErrorCode["ProfileNotFound"] = "ProfileNotFound";
    SteamErrorCode["OwnedGamesNotFound"] = "OwnedGamesNotFound";
})(SteamErrorCode || (SteamErrorCode = {}));
export const GIVEAWAY_DEFAULT_POOLING_TIME_MS = 10000;
export const DEFAULT_TIME_PRESETS = [
    {
        label: 'days',
        options: Array.from({ length: 9 }, (_, i) => ({
            label: i.toString(),
            value: i,
        })),
    },
    {
        label: 'hours',
        options: Array.from({ length: 24 }, (_, i) => ({
            label: `${i}:00`,
            value: i,
        })),
    },
    {
        label: 'minutes',
        options: Array.from({ length: 12 }, (_, i) => {
            const minute = i * 5;
            return {
                label: `00:${minute.toString().padStart(2, '0')}`,
                value: minute,
            };
        }),
    },
];
export const DEFAULT_DURATION_PRESETS = [
    {
        label: '20 minutes',
        value: 1000 * 60 * 20,
    },
    {
        label: '1 hour',
        value: 1000 * 60 * 60,
    },
    {
        label: '1 day',
        value: 1000 * 60 * 60 * 24,
    },
    {
        label: '3 days',
        value: 1000 * 60 * 60 * 24 * 3,
    },
];
export const MIN_REPEAT_TIMES = 1;
export const MAX_REPEAT_TIMES = 9;
export const MIN_DURATION_TIME = 1000 * 60 * 5;
export const MIN_DURATION_TIME_MESSAGE = 'Duration must be at least 5 minutes';
export const MIN_DAILY_WINS = 1;
export const MAX_DAILY_WINS = 10;
export const MIN_WINNERS_PER_GIVEAWAY = 1;
export const MAX_WINNERS_PER_GIVEAWAY = 10;
export const MIN_VOUCHER_COUNT_PER_WINNER = 1;
export const MAX_VOUCHER_COUNT_PER_WINNER = 10;
export const MIN_PARTICIPANTS_TO_START = 1;
export const MAX_PARTICIPANTS_TO_START = 1000;
export const MIN_WAIT_TIME = 1000 * 60 * 5; // 5 minutes
export const MAX_WAIT_TIME = 1000 * 60 * 60 * 24; // 24 hours
export const DEFAULT_WAIT_TIME = 1000 * 60 * 60 * 2; // 2 hours
export const WAIT_TIME_PRESETS = [
    { label: '5 minutes', value: 1000 * 60 * 5 },
    { label: '15 minutes', value: 1000 * 60 * 15 },
    { label: '30 minutes', value: 1000 * 60 * 30 },
    { label: '1 hour', value: 1000 * 60 * 60 },
    { label: '2 hours', value: 1000 * 60 * 60 * 2 },
    { label: '6 hours', value: 1000 * 60 * 60 * 6 },
    { label: '12 hours', value: 1000 * 60 * 60 * 12 },
    { label: '24 hours', value: 1000 * 60 * 60 * 24 },
];
export const createGiveawayFormSchema = z.object({
    durationTime: z.number().min(5000 * 60, { message: MIN_DURATION_TIME_MESSAGE }),
    repeatTimes: z.union([z.null(), z.undefined(), z.number().min(1, { message: 'Repeat times must be at least 1' })]),
    isRepeatingEnabled: z.boolean().optional(),
    isTwitchSubscribersOnly: z.boolean().optional(),
    blockBannedUsers: z.boolean().optional(),
    maxWinners: z.number().min(1, { message: 'Repeat times must be at least 1' }),
    isMaxDailyWinsEnabled: z.boolean(),
    maxDailyUserWins: z.union([z.null(), z.undefined(), z.number().min(1, { message: 'Max Daily Wins must be at least 1' })]),
    voucherCountPerWinner: z.number().min(MIN_VOUCHER_COUNT_PER_WINNER).max(MAX_VOUCHER_COUNT_PER_WINNER),
    isMinParticipantsEnabled: z.boolean().optional(),
    minParticipantsToStart: z.union([
        z.null(),
        z.undefined(),
        z.number()
            .min(MIN_PARTICIPANTS_TO_START, { message: `Min Participants must be at least ${MIN_PARTICIPANTS_TO_START}` })
            .max(MAX_PARTICIPANTS_TO_START, { message: `Min Participants must be at most ${MAX_PARTICIPANTS_TO_START}` }),
    ]),
    maxWaitTime: z.union([
        z.null(),
        z.undefined(),
        z.number()
            .min(MIN_WAIT_TIME, { message: 'Max wait time must be at least 5 minutes' })
            .max(MAX_WAIT_TIME, { message: 'Max wait time must be at most 24 hours' }),
    ]),
});
export function isValidDuration(durationObj) {
    var _a, _b, _c;
    const daysMs = ((_a = durationObj.days) !== null && _a !== void 0 ? _a : 0) * 1000 * 60 * 60 * 24;
    const hoursMs = ((_b = durationObj.hours) !== null && _b !== void 0 ? _b : 0) * 1000 * 60 * 60;
    const minutesMs = ((_c = durationObj.minutes) !== null && _c !== void 0 ? _c : 0) * 1000 * 60;
    const totalMs = daysMs + hoursMs + minutesMs;
    return totalMs >= MIN_DURATION_TIME;
}
export const timeDurationFormSchema = z.object({
    days: z.number()
        .min(0)
        .optional(),
    hours: z.number()
        .min(0)
        .optional(),
    minutes: z.number()
        .min(0)
        .optional(),
}).refine((data) => {
    return isValidDuration(data);
}, { message: MIN_DURATION_TIME_MESSAGE });
export const RESOLVE_GIVEAWAY_MARGIN_MS = 2500;
export var UpdatePoolActionType;
(function (UpdatePoolActionType) {
    UpdatePoolActionType["Add"] = "ADD";
    UpdatePoolActionType["Remove"] = "REMOVE";
})(UpdatePoolActionType || (UpdatePoolActionType = {}));
export var GiveawayOverlayParams;
(function (GiveawayOverlayParams) {
    GiveawayOverlayParams["AutoHide"] = "autohide";
    GiveawayOverlayParams["QRCode"] = "qr";
    GiveawayOverlayParams["EnterLink"] = "enter_link";
})(GiveawayOverlayParams || (GiveawayOverlayParams = {}));
export const GIVEAWAY_OVERLAY_DEMO_PAGE_ROUTE = 'g-demo';
